import './AddNotes.scss';
import PrimaryButton from "../../../../../components/prime-react-overrides/button/Button"
import { Controller, useForm } from "react-hook-form"
import { NOTES_FORM_KEYS, notesFormSchema } from "./AddNotesConfig"
import { joiResolver } from "@hookform/resolvers/joi"
import { classNames } from "primereact/utils"

import { useAddNotesMutation } from "../../../../../services/attendance-portal/notes.js"
import Modal from "../../../../../components/prime-react-overrides/modal/Modal"
import InputTextarea from "../../../../../components/prime-react-overrides/input-text-area/InputTextarea"
import InputText from "../../../../../components/prime-react-overrides/input-text/InputText"
import Calendar from "../../../../../components/prime-react-overrides/calendar/Calendar"
import UploadAndPreview from "../../../../../components/upload-preview/UploadAndPreview"
import { useState } from "react"



export const AddNotesModal = ({ visible, onHide }) => {
  const [addNotes, { isLoading }] = useAddNotesMutation()
  const [image, setImage] = useState({link: null, name: "", type: ""})

  const { control, formState: { errors }, handleSubmit, reset } = useForm({
    resolver: joiResolver(notesFormSchema),
    defaultValues: {
      [NOTES_FORM_KEYS.HEADING]: "",
      [NOTES_FORM_KEYS.CONTENT]: "",
      [NOTES_FORM_KEYS.VALID_TILL]: null,
    }
  })


  async function handleAddNotes(noteFormData) {
    noteFormData.image = image.link
    await addNotes(noteFormData)
    reset()
    setImage({link: null, name: "", type: ""})
    onHide()
  }



  return (
    <Modal className="AddNewFeedModal" visible={visible} onHide={onHide} draggable={false} header='Add Note' breakpoints={{ '640px': '100vw' }} style={{ width: '60vw' }}>
      <form onSubmit={handleSubmit(handleAddNotes)} >
        <div className="field">
          <label className="block mb-2">Heading</label>
          <Controller name={NOTES_FORM_KEYS.HEADING} control={control} render={({ field, fieldState }) => (
            <InputText id={field[NOTES_FORM_KEYS.HEADING]}  {...field} className={classNames({ 'p-invalid': fieldState.error }, 'block w-full')} />
          )} />
          <small className='p-error font-medium block' >{errors[NOTES_FORM_KEYS.HEADING] && errors[NOTES_FORM_KEYS.HEADING].message}</small>
        </div>

        <div className="field">
          <label className="block mb-2">Content *</label>
          <Controller name={NOTES_FORM_KEYS.CONTENT} control={control} render={({ field, fieldState }) => (
            <InputTextarea id={field[NOTES_FORM_KEYS.CONTENT]}  {...field} className={classNames({ 'p-invalid': fieldState.error }, 'block w-full')} rows={6} autoResize />
          )} />
          <small className='p-error font-medium block' >{errors[NOTES_FORM_KEYS.CONTENT] && errors[NOTES_FORM_KEYS.CONTENT].message}</small>
        </div>

        <div className="grid">
          <div className="col">
            <div className="field">
              <UploadAndPreview className='AddImageInNote' docData={image} title="Add Image" acceptType={['image/png', 'image/jpg']} setDocData={setImage}  />
            </div>
            
          </div>
          <div className="col">
            <div className="field">
              <label className="block mb-2">Valid Till</label>
              <Controller name={NOTES_FORM_KEYS.VALID_TILL} control={control} render={({ field, fieldState }) => (
                <Calendar showTime hourFormat="12" showIcon minDate={new Date()} id={field[NOTES_FORM_KEYS.VALID_TILL]}  {...field} className={classNames({ 'p-invalid': fieldState.error }, 'w-full')} />
              )} />
              <small className='p-error font-medium block' >{errors[NOTES_FORM_KEYS.VALID_TILL] && errors[NOTES_FORM_KEYS.VALID_TILL].message}</small>
            </div>
          </div>
        </div>


        <div className="flex justify-content-center mt-3">
          <PrimaryButton type="submit" label="Add" loading={isLoading} />
        </div>
      </form >
    </Modal>
  )
}


